import React from "react";
import { default as Notifications } from "components/Dashboard/Dashboard_Notifications";

const Card_PendingRequests = (props) => {
	// console.log(props);

	return (
		<article className="card card-notifications">
			<Notifications />
		</article>
	);
};

export default Card_PendingRequests;
